import React from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import { getItemValue } from '../helpers';
import CustomPair from '../pair';

export default function ComponentData({ ...props }) {

  return (
    <>
      <Typography
        align="center"
        color="primary"
        variant="h5"
      >
        {'Meus dados'}<br></br>
      </Typography>
      { props.state && (
          <Grid container={true} direction='column'>
            <Grid item>
              <CustomPair first={"Cliente"} second={getItemValue(props.state, ['user', 'name'], '')} />
            </Grid>
            <Grid item>
              <CustomPair first="Agência" second={getItemValue(props.state, ['user', 'classe', 0, 'serie', 'school', 'name'], '')} />
            </Grid>
            <Grid item>
              <CustomPair first="Série" second={getItemValue(props.state, ['user', 'classe', 0, 'serie', 'name'], '')} />
            </Grid>
          </Grid>
        )
      }
    </>
  )

}
